module.exports = __webpack_public_path__ + "static/media/onePattern.87631917.png";